import React from "react";
import {Divider} from "antd";
import companyValidation from "../companyValidation";
import FormInput from "../../../components/FormInput/FormInput";

const FirstStepCompany = <>
    <Divider orientation="left">Company Data</Divider>

    <FormInput placeholder='Planet Soft' label='Company Name' name='companyName' rules={companyValidation.companyName}/>
    <FormInput placeholder='4600092100009' label='Company PIB' name='companyPib' rules={companyValidation.companyPib}/>
    <FormInput placeholder='Beogradska 11' label='Street' name='street' rules={companyValidation.street}/>
    <FormInput placeholder='Belgrade' label='City' name='city' rules={companyValidation.city}/>
    <FormInput placeholder='11160' label='Zip Code' name='zipCode' rules={companyValidation.zipCode}/>
    <FormInput placeholder='Serbia' label='Country' name='country' rules={companyValidation.country}/>

</>;

export default FirstStepCompany;